import React from 'react';
import Hero from '../components/Hero';
import Products from '../components/Products';
import OurExpertise from '../components/OurWorks';
import Clients from '../components/Clients';
// import Testimonials from '../components/Testimonials';
import Blog from '../components/Blog';
import Contact from '../components/Contact';
import CTA from '../components/CTA';
// import Services from '../components/Services';

import { Helmet } from 'react-helmet-async';

const Home = () => {
    return (
        <>
          <Helmet>
                <title>Mini App Tech | Software Development Company in Madurai</title>
                <meta name="title" content="Mini App Tech | Software Development Company in Madurai" />
                <meta name="description" content="Mini App Tech provides Mobile App Development, Web Development, ERP Software, CRM Software, Chit Fund Software, Finance Software, E-commerce Solutions, and Custom Software Development in Madurai, Tamil Nadu." />
                <meta name="keywords" content="Mini App Tech, Software Company Madurai, Mobile App Development, Web Development, ERP Software, CRM Software, Chit Fund Software, Finance Software, School Management Software, Hospital Management Software, E-commerce Development, Custom Software Development" />
                <meta name="author" content="Mini App Tech" />
                <meta name="robots" content="index, follow" />
                <meta name="language" content="English" />
                <meta name="revisit-after" content="7 days" />

                <link rel="canonical" href="https://www.miniapptech.in" />

                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.miniapptech.in" />
                <meta property="og:title" content="Mini App Tech | Software Development Company in Madurai" />
                <meta property="og:description" content="Custom Software, Mobile Apps, ERP, CRM, Chit Fund Software, Finance Software, and Business Automation Solutions." />
                <meta property="og:image" content="https://www.miniapptech.in/assets/images/logo.png" />
                <meta property="og:site_name" content="Mini App Tech" />
                <meta property="og:locale" content="en_IN" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://www.miniapptech.in" />
                <meta name="twitter:title" content="Mini App Tech | Software Development Company in Madurai" />
                <meta name="twitter:description" content="Leading Software Development Company offering ERP, CRM, Mobile Apps, Web Development and Business Automation Solutions." />
                <meta name="twitter:image" content="https://www.miniapptech.in/assets/images/logo.png" />

                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />

                <meta name="geo.region" content="IN-TN" />
                <meta name="geo.placename" content="Madurai" />
                <meta name="geo.position" content="9.9252;78.1198" />
                <meta name="ICBM" content="9.9252, 78.1198" />
            </Helmet>
            <Hero />
            <Clients/>
            <OurExpertise />
            <Products />
            {/* <Services /> */}
            {/* <Testimonials /> */}
            <Blog />
            <CTA />
            <Contact />
        </>
    );
};

export default Home;
